import React from 'react';
import {getPipelineComponent} from '../../../utils/pipeline_utils';

export function PipelineStepComponent({step, ...otherProps}) {
    const PipeStep = getPipelineComponent(step);
    return (
        <PipeStep
            step={step}
            {...otherProps}
        />
    )
}
